/**
 * Employee Web — `/me/requests` pathless parent.
 *
 * Phase 4 Plan 04-04 Task 2. Hosts the requests inbox index + new-request
 * route + detail route under a shared pathless wrapper so every child route
 * inherits the /me breadcrumb chain (`leaves:page.my_requests`).
 */
import type { JSX } from "react";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/me/requests")({
  staticData: { breadcrumb: { labelKey: "requests:page.my_requests" } },
  component: RequestsParentRoute,
});

function RequestsParentRoute(): JSX.Element {
  return <Outlet />;
}
